/* eslint-disable max-len */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { selectAppConfig } from 'services/bootup/selectors'
import { selectSite } from 'services/site/selectors'
import { ContactSupportCopy, MobileFooter, WebFooter } from '../util'

import { Title, SectionTitle, SectionContent, PrivacyLinks, PrivacyWrapper } from '../util'

const mapStateToProps = (state) => ({
  appConfig: selectAppConfig(state),
  site: selectSite(state),
})

const mapDispatchToActions = {}

function AgeGateContent (props) {
  const { appConfig, site, isMobile } = props
  const appName = site.name || 'MapMyRun'

  return (
    <PrivacyWrapper>
      <Title>
        <FormattedMessage id='privacy_center.help.title' defaultMessage="Why can't I access my account?" />
      </Title>

      <SectionTitle>
        <FormattedMessage id='privacy_center.help.terms_not_met.title' defaultMessage="Terms not met" />
      </SectionTitle>

      <SectionContent>
        <FormattedMessage
          id='privacy_center.help.terms_not_met.content'
          defaultMessage="Unfortunately, you are not eligible to use the services provided by { appName } at this time. "
          values={ { appName } }
        />
      </SectionContent>

      <PrivacyLinks
        exportData={true}
        accountDelete={true}
        contactSupport={!appConfig.isChina}
        logout={true}
        isMobile={isMobile}
        screenName='age_gate'
      />

      {appConfig.isChina ?
        <SectionContent>
          <ContactSupportCopy />
        </SectionContent>
      : null}

      { isMobile ? <MobileFooter /> : <WebFooter /> }
    </PrivacyWrapper>
  )
}

AgeGateContent.propTypes = {
  appConfig: PropTypes.object,
  site: PropTypes.object,
  isMobile: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToActions)(AgeGateContent)
